@for (question of questions | sortGroupedQuestions; track question.id) {
  @if (question.type === 'GROUP' || question.type === 'CHARITY_GROUP') {
    @if (DEBUG) { <p>Group: <span class="badge bg-secondary">{{ question.id }}</span></p> }
    @for (subQuestions of question.groupedQuestions!! | keyvalue; track $index) {
      @let finalGroup = $last;
      @for (subQuestion of subQuestions.value | filterTypes; track $index) {
        <div class="col-md-5 col-sm-12 py-3 mr-4 {{ !finalGroup || !$last ? 'mb-3' : ''}}">
          <div class="question" [tabindex]="active ? 0 : -1" [attr.data-question]="subQuestion.id" [innerHTML]="getMessage(subQuestion)"></div>
          @if (DEBUG) { <span class="badge bg-secondary">{{ subQuestion.id }}</span> }
        </div>
        <div class="col-md-5 col-sm-10">
            <p [tabindex]="active ? 0 : -1"
               [attr.aria-label]="'Answer to ' + getMessage(subQuestion)"
               [innerHTML]="getAnswer(subQuestion)"></p>
        </div>
        @if (subQuestion.edited) {
          <p><em>(edited)</em></p>
        }
      }
    }
  } @else {
    <div class="col-md-5 col-sm-12 align-items-center py-3 mr-4 {{ !$last ? 'mb-4' : ''}}">
      <div class="question" [tabindex]="active ? 0 : -1" [attr.data-question]="question.id" [innerHTML]="getMessage(question)"></div>
      @if (DEBUG) { <span class="badge bg-secondary">{{ question.id }}</span> }
    </div>
    <div class="col-md-5 col-sm-10 align-items-center py-3">
        <p [tabindex]="active ? 0 : -1"
           [attr.aria-label]="'Answer to ' + getMessage(question)"
           [innerHTML]="getAnswer(question)"></p>
      @if (question.edited) {
        <p><em>(edited)</em></p>
      }
    </div>
  }
  <div class="col-6 col-md-2 px-0 mx-1 mx-sm-0 mb-5 mb-md-0 py-auto">
    <button class="btn rounded-pill edit" id="edit-{{question.id}}"
            type="button" (click)="editQuestion(question, topic)" (keyup.enter)="editQuestion(question, topic)"
            [attr.aria-label]="'Edit response to question ' + getMessage(question)">
      @if (loading) {
        <span class="spinner-border spinner-border-sm mr-1"></span>
      }
      {{ messages.getText('btn.edit', 'Edit') }}
      <img class="mx-2" src="https://bequeathedassets.s3.eu-west-2.amazonaws.com/myintent/icons/edit_roundel_green.svg" alt="Pencil outline">
    </button>
  </div>
  <edit-question-popup #editQuestionPopup [summary]="summary" [type]="type" />
}

<edit-confirmation-dialog #editConfirm></edit-confirmation-dialog>
